import React from 'react';

import Layout from '../components/layout_faq';
import HeroPageIntro from '../sections/HeroPageIntro';
import LayoutPageWrapper from '../components/LayoutPageWrapper';
import Heading from '../components/Heading';

const IndexPage = () => (
  <Layout>
    <HeroPageIntro title="FAQ" />
    <LayoutPageWrapper horizontalPadding="Small">

    <Heading type="h2" size="Small">Can multiple users work on the same test suites?</Heading>

    <p>Yes,  multiple users can easily work on the same test suites.</p>

    <p>All the details are provided in the <a href="https://endtest.io/guides/docs/adding-collaborators/" target="_blank" title="Adding Collaborators">Adding Collaborators</a> chapter from our <a href="https://endtest.io/guides/docs/" target="_blank" title="Documentation">Documentation</a>.</p>

    <Heading type="h2" size="Small">Can I execute tests for a Web Application that is accessible only from my workplace?</Heading>

    <p>Yes, that is possible.</p>

    <p>All the details are provided in the <a href="https://endtest.io/guides/docs/web-applications-with-restricted-access/" target="_blank" title="Web Applications with restricted access">Web Applications with restricted access</a> chapter from our <a href="https://endtest.io/guides/docs/" target="_blank" title="Documentation">Documentation</a>.</p>

    <Heading type="h2" size="Small">Do I need to add Waits for any steps?</Heading>

    <p>No, there is no need to add any Waits, since our engine can automatically detect when to wait before executing a step.</p>

    <p>We do offer you the flexibility to modify the Element Load Timeout and Page Load Timeout values for each test suite in the Advanced Settings section.</p>

    <p>All the details are provided in the <a href="https://endtest.io/guides/docs/advanced-settings/" target="_blank" title="Advanced Settings">Advanced Settings</a> chapter from our <a href="https://endtest.io/guides/docs/" target="_blank" title="Documentation">Documentation</a>.</p>

    <Heading type="h2" size="Small">What kind of applications can I create tests for?</Heading>

    <p>You can create and execute tests for Web Applications and Mobile Applications.</p>

    <Heading type="h2" size="Small">I'm running a test for a Web Application and Endtest can't find an element. What can I do?</Heading>

    <p>Follow the steps from the <a href="https://endtest.io/guides/docs/finding-elements-in-web-applications/" target="_blank" title="Finding elements in Web Applications">Finding elements in Web Applications</a> chapter from our <a href="https://endtest.io/guides/docs/" target="_blank" title="Documentation">Documentation</a>.</p>

    <Heading type="h2" size="Small">How do Self-Healing Tests work?</Heading>

    <p>All the details are provided in the <a href="https://endtest.io/guides/docs/self-healing-tests/" target="_blank" title="Self-Healing Tests">Self-Healing Tests</a> chapter from our <a href="https://endtest.io/guides/docs/" target="_blank" title="Documentation">Documentation</a>.</p>

    <Heading type="h2" size="Small">How do I get the ID, Name, XPath, Class Name and CSS Selector for the elements from the Web Application that I am testing?</Heading>

    <p>All the details are provided in the <a href="https://endtest.io/guides/docs/finding-elements-in-web-applications/" target="_blank" title="Finding elements in Web Applications">Finding elements in Web Applications</a> chapter from our <a href="https://endtest.io/guides/docs/" target="_blank" title="Documentation">Documentation</a>.</p>

    <Heading type="h2" size="Small">How do I get the ID, Accessibility ID, Name, XPath, Class Name, Android UI Automator, iOS UI Automation for the elements from the Mobile Application that I am testing?</Heading>

    <p>All the details are provided in the <a href="https://endtest.io/guides/docs/finding-elements-in-mobile-applications/" target="_blank" title="Finding elements in Mobile Applications">Finding elements in Mobile Applications</a> chapter from our <a href="https://endtest.io/guides/docs/" target="_blank" title="Documentation">Documentation</a>.</p>

    <Heading type="h2" size="Small">How do I get the Download URL for my APK or IPA file?</Heading>

    <p>All the details are provided in the <a href="https://endtest.io/guides/docs/how-to-execute-mobile-tests/" target="_blank" title="How to execute Mobile Tests">How to execute Mobile Tests</a> chapter from our <a href="https://endtest.io/guides/docs/" target="_blank" title="Documentation">Documentation</a>.</p>

    <Heading type="h2" size="Small">What can I do if the Web Application that I am testing is using a reCAPTCHA system?</Heading>

    <p>All the details are provided in the <a href="https://endtest.io/guides/docs/dealing-with-recaptcha/" target="_blank" title="Dealing with reCAPTCHA">Dealing with reCAPTCHA</a> chapter from our <a href="https://endtest.io/guides/docs/" target="_blank" title="Documentation">Documentation</a>.</p>

    <Heading type="h2" size="Small">Can I test browser extensions with Endtest?</Heading>
    <p>Yes, that is possible.</p>

    <p>All the details are provided in the <a href="https://endtest.io/guides/docs/how-to-test-chrome-extensions/" target="_blank" title="How to test Chrome Extensions">How to test Chrome Extensions</a> chapter from our <a href="https://endtest.io/guides/docs/" target="_blank" title="Documentation">Documentation</a>.</p>

    </LayoutPageWrapper>
  </Layout>
);

export default IndexPage;
